import { render, staticRenderFns } from "./AddNewFlagModal.vue?vue&type=template&id=511723f8&scoped=true&"
import script from "./AddNewFlagModal.vue?vue&type=script&lang=js&"
export * from "./AddNewFlagModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewFlagModal.vue?vue&type=style&index=0&id=511723f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511723f8",
  null
  
)

export default component.exports